import React, { useState, useEffect } from "react";
import "./Event.css";
import { URL, IMAGE_MAP } from './constants';
import hobbitlora from '../assets/images/hobbitlora.gif';

export default function Event({
  id,
  startTime,
  endTime,
  name,
  description,
  location,
  mandatory,
  register,
  initial_registered,
  onRegistrationChange, // callback from parent
  registeredUsers,
}) {
  const [registered, setRegistered] = useState(initial_registered);

  // Keep local state in sync with parent changes
  useEffect(() => {
    setRegistered(initial_registered);
  }, [initial_registered]);

  const handleRegistration = async (deregister = false) => {
    try {
      const res = await fetch(`${URL}/register_event`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ event_id: id, deregister })
      });

      if (!res.ok) throw new Error("Request failed");

      setRegistered(!deregister);

      // Notify parent of the change
      if (onRegistrationChange) onRegistrationChange(id, !deregister);
    } catch (err) {
      console.error(err);
      alert("Could not update registration.");
    }
  };

  let statusElement;
  if (mandatory) {
    statusElement = <><b>Mandatory</b><br /></>;
  } else if (register) {
    statusElement = registered ? (
      <>
        <b>Registered</b>{" "}
        <span
          className="register-link"
          onClick={() => handleRegistration(true)}
        >
          (Leave)
        </span>
        <br />
      </>
    ) : (
      <>
        <b>Unregistered</b>{" "}
        <span
          className="register-link"
          onClick={() => handleRegistration(false)}
        >
          (Join)
        </span>
        <br />
      </>
    );
  } else {
    statusElement = null;
  }

  return (
    <div className="event">
      <div className="event-header">
        <div className="event-name">{name}</div>
        <div className="event-time">{startTime} - {endTime}</div>
      </div>

      <div className="event-description">
        {statusElement}
        {location ? <> <i>{location}</i> <br /> </> : ''}
        {description ? <> <br/>{description} </> : ''}
        {registeredUsers && registeredUsers.length > 0 && (
          <div className="registered-users">
            {registeredUsers.map((user) => (
              <img
                key={user.nickname}
                className="registered-user-img"
                src={IMAGE_MAP[user.image] || hobbitlora}
                alt={user.nickname}
                title={user.nickname}  // optional hover tooltip
              />
            ))}
          </div>
        )}

      </div>
    </div>
  );
}